import {Component, ComponentRef, Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {Subject} from 'rxjs';

import {ModalContainerComponent} from '../components/modal-container/modal-container.component';

@Injectable({
  providedIn: 'root'
})
export class ModalRef {

  private result$ = new Subject<any>();
  private modal: ComponentRef<Component>;
  private modalContainer: ComponentRef<ModalContainerComponent>;

  constructor() {
  }

  setModalComponentRef(modalComponentRef: ComponentRef<ModalContainerComponent>): void {
    this.modalContainer = modalComponentRef;
  }

  setResult(result: any) {
    this.result$.next(result);
  }

  setModalRef(modalComponentRef: ComponentRef<Component>): void {
    this.modal = modalComponentRef;
  }

  close(output?: any): void {
    this.result$.next(output);
    this.destroy$();
  }

  dismiss(): void {
    this.destroy$();
  }

  onResult(): Observable<any> {
    this.result$ = new Subject<any>();
    return this.result$.asObservable();
  }

  private destroy$(): void {
    this.modal.destroy();
    this.modalContainer.destroy();
    this.result$.complete();
  }

}
